import React, { useEffect, useState } from "react";

import SwiperCore from "swiper";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { ReviewCard } from "../ReviewCard/ReviewCard";
import { ReviewPopup } from "../ReviewPopup/ReviewPopup";

import { Wrapper } from "./styles";

import type { Category, Review } from "../../types/reviews";

import "swiper/css";
import "swiper/css/pagination";

type ReviewBlockProps = {
    reviews: Review[];
    categories: Category[]
};

export const ReviewSection: React.FC<ReviewBlockProps> = ({ reviews, categories }) => {
  const [selectedReview, setSelectedReview] = useState<Review | null>(null);
  const [swiperInstance, setSwiperInstance] = useState<SwiperCore | null>(null);

  useEffect(() => {
    if (!swiperInstance) return;

    if (selectedReview) {
      swiperInstance.autoplay?.stop();
    } else {
      swiperInstance.autoplay?.start();
    }
  }, [selectedReview, swiperInstance]);

  return (
    <Wrapper>
      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ dynamicBullets: true }}
        autoplay={{ delay: 5000 }}
        onSwiper={setSwiperInstance}
        spaceBetween={24}
        slidesPerView="auto"
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          451: {
            slidesPerView: 2,
          },
          980: {
            slidesPerView: 3,
          }
        }}
      >
        {reviews.map((review) => {
          const category = categories.find(cat => cat.id === review.product.product_category);

          return (
            <SwiperSlide
              key={review.id}>
              <ReviewCard
                review={review}
                categoryTitle={category?.title || "Без категории"}
                onClick={() => setSelectedReview(review)}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
      {selectedReview && (
        <ReviewPopup
          visible={true}
          onClose={() => setSelectedReview(null)}
          review={selectedReview}
        />
      )}
    </Wrapper>
  );
};
